import http from './http';

const ors_api = 'https://api.openrouteservice.org/v2/isochrones/';
export const ors_modes = {
  'foot-walking': 'foot-walking',
  'cycling-regular': 'cycling-regular'
};

const compute_ors_params = (lat,  lon,  range,  interval) => ({
  'locations': [
    [lat,lon]
  ],
  'area_units': 'km',
  'attributes': ['total_pop'],
  'range_type': 'time',
  'range': [range],
  'interval': interval
});

export const getIsochrones = (
  lat,
  lon,
  {
    range = 900,
    interval = 300,
    url = ors_api,
    mode = ors_modes['foot-walking']
  } = {}
) =>
  http.post(url + mode, compute_ors_params(lat,  lon,  range,  interval))
    .then(featureCollection => featureCollection);


